import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPromo } from '../../actions/cartActions';
import useAxios
 from '../../axios/useAxios';
import { useNavigate } from 'react-router-dom';
import { findUser, saveUser } from '../../actions/userActions';
import StepBar from '../../components/Step_bar';
import { auth } from '../../firebase/firebaseConfig';
import HeaderCart from '../../components/HeaderCart';
import Pikkopointsbox from '../../components/pikko-box/PikkoPointBox.jsx';
import arrow from '../../styles/img/arrow/arrow.svg';
import google from '../../styles/img/google.svg';
import facebook from '../../styles/img/facebook.svg';
import mail from '../../styles/img/mail.svg';
import UserInfo from '../../components/UserInfo.jsx';
import tiret_coupons from '../../styles/img/tiret_coupons.svg';
import promo1 from '../../styles/img/1sur3.svg';
import promo2 from '../../styles/img/2sur3.svg';
import promo3 from '../../styles/img/3sur3.svg';
import promoadd from '../../styles/img/promoadd.svg';
import BackButton from '../../components/button/BackButton.jsx';
import promo5euro from '../../styles/img/promo/promo5euro.svg';
import closepopup from '../../styles/img/promo/closepopup.svg';
import {
  ACCOUNT,
  CART,
  CONVERSION,
  INVITATION,
  PROMO,
  RECOMPENSES,
  SCAN,
} from '../../constants/routes';
import { notifySuccess, notifyWarning } from '../../utils/Notify';
import { isAllowedToPay, MINIMUM_PRICE } from '../../utils/Validator';
import GetUserInfo from '../account/GetUserInfo.jsx';
import PrimaryButton from '../../components/button/PrimaryButton';
import HandleGoogle from '../auth/login/HandleGoogle';
import HandleFacebook from '../auth/login/HandleFacebook';
import HandleConnectEmail from '../auth/login/HandleConnectEmail';
import { displayCouponNameProperly } from '../../utils/StringUtils';
import { useFunnelTracking } from '../../posthog/funnelTracking';

const PromoScreen = () => {
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user);
  const { loading } = useSelector((state) => state.user);
  const { store } = useSelector((state) => state.store);
  const { cartItems } = useSelector((state) => state.cart);
  const { loadingPromos } = useSelector((state) => state.cart);
  const [activateLoading, setActivateLoading] = useState(false);
  const [promoCode, setPromoCode] = useState();
  const [isPopupVisible, setIsPopUpVisible] = useState(false);
  const [inscription, setInscription] = useState(true);
  const [mailvisible, setMail] = useState(false);
  const [inputpassword, setPassword] = useState('');
  const [inputemail, setEmail] = useState('');
  const [activePromoIndex, setActivePromoIndex] = useState(-1);
  const [promoIndex, setPromoIndex] = useState(-1);
  const [promoPikkoday, setPromoPikkoday] = useState(null);
  const [pikkoday, setPikkoday] = useState(false);
  const initialWelcomePromoo = [
    { name: 'promo1e' },
    { name: 'promo2e' },
    { name: 'promo5e' },
  ];
  const { trackPageViewPromo } = useFunnelTracking();

  useEffect(() => {
    trackPageViewPromo({});
  }, [trackPageViewPromo]);

  useEffect(() => {
    if ((store && store.permissions && store.permissions.promo === false)) {
      navigate(CART);
    }
  }, [store]);

  const welcomeCurrentPromo =
    user && user.currentPromo
      ? user.currentPromo.filter((item) => item.type === 'welcome')
      : [];
  welcomeCurrentPromo.sort((a, b) => a.name.localeCompare(b.name));

  function areAllElementsIncluded(array1, array2) {
    const countMap1 = new Map();
    const countMap2 = new Map();

    // Remplir la première carte de comptage
    array1.forEach((element) => {
      countMap1.set(element, (countMap1.get(element) || 0) + 1);
    });

    // Remplir la deuxième carte de comptage
    array2.forEach((element) => {
      countMap2.set(element, (countMap2.get(element) || 0) + 1);
    });

    // Vérifier que chaque élément du tableau 1 est inclus dans le tableau 2 avec suffisamment d'occurrences
    return Array.from(countMap1.entries()).every(([element, count]) => {
      return countMap2.get(element) >= count;
    });
  }

  const GetRedirectInfo = async (auth, user) => {
    try {
      const data = await GetUserInfo(auth, user);
      dispatch(
        saveUser(data.newResult.profile, axiosInstance, cartItems, navigate),
      );
    } catch (error) {
      console.error(
        "Une erreur s'est produite lors de l'authentification avec Google:",
        error,
      );
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    auth.onAuthStateChanged(async (firebaseUser) => {
      if (user && user._id) {
        dispatch(findUser(user, axiosInstance));
      } else if (firebaseUser && firebaseUser.email) {
        await GetRedirectInfo(auth, user);
      }
    });
  }, [auth]);

  useEffect(() => {
    if (user && user._id) {
      //ajouter promoPikkoday dans currentPromo
      isFriday();
    }
    if (localStorage.getItem('promo_index')) {
      if (
        sortedPromoCadeaux[parseInt(localStorage.getItem('promo_index'))] ||
        parseInt(localStorage.getItem('promo_index')) === 1000
      ) {
        setActivePromoIndex(parseInt(localStorage.getItem('promo_index')));
      }
    }
    if (user && user._id && user._id.length > 0) setIsPopUpVisible(false);
    else navigate(INVITATION);
  }, [loading]);

  const promoCadeaux = () => {
    if (!user.currentPromo) {
      return [];
    }
    const promos = user.currentPromo.filter(
      (item) =>
        item.type !== 'welcome' &&
        (item.category === 'substract' || item.category === 'pourcentage') &&
        (item.type !== 'business' ||
          (item.type === 'business' &&
            store.id === '65b8bde65a0ef81ff30473bf')),
    );
    return promos;
  };

  const sortedPromoCadeaux = promoCadeaux().sort((a, b) =>
    a.name.localeCompare(b.name),
  );

  useEffect(() => {
    if (!cartItems?.promo) {
      setActivePromoIndex(-1);
    }
    if (
      localStorage.getItem('promo_index') &&
      parseInt(localStorage.getItem('promo_index')) === 1000
    ) {
      return;
    }
    if (user?.currentPromo && user.currentPromo.length > 0) {
      //ajouter un json promo dans currentPromo
      const index = sortedPromoCadeaux.findIndex(
        (item) => item.name === cartItems?.promo,
      );
      if (index >= 0) {
        setActivePromoIndex(index);
      }
    }
  }, [user, cartItems]);

  const checkAllPromoUsed = () => {
    const welcomePromo = user.currentPromo.filter(
      (item) => item.type === 'welcome',
    );
    if (welcomePromo && welcomePromo.length > 0) {
      return false;
    } else return true;
  };

  const callBackRedirect = () => {
    setActivateLoading(false);
    notifySuccess(
      'Promotion appliquée',
      `Ta promotion vient d'être appliquée à ton panier.`,
      "J'ai compris",
    );
    navigate(CART);
  };
  const applyPromo = (promoItem, index) => {
    // Check si l'utilisateur tente d'activer une 2nd promotion identique à celle déjà active

    if (
      activePromoIndex >= 0 &&
      activePromoIndex !== index &&
      activePromoIndex !== 1000
    ) {
      const currentPromo = sortedPromoCadeaux[activePromoIndex];
      if (currentPromo.name === promoItem.name) {
        notifyWarning(
          'Promotion déjà active',
          'Tu ne peux pas activer deux promotions identiques',
        );
        return;
      }
    }
    if (index === 1000) {
      setActivateLoading(true);
      localStorage.setItem('promo_index', 1000);
    }
    if (promoItem.type !== 'pikkoday') {
      localStorage.removeItem('promo_index');
    }

    if (promoItem.name === 'promo5e' && !user._id) {
      setIsPopUpVisible(true);
    } else {
      dispatch(
        getPromo(
          cartItems,
          axiosInstance,
          promoItem,
          callBackRedirect,
          setActivateLoading,
        ),
      );
    }
  };

  const checkUsed = (promoCode) => {
    const welcomePromo = user.currentPromo
      .filter((item) => item.type === 'welcome')
      .sort((a, b) => a.name.localeCompare(b.name));
    if (welcomePromo && welcomePromo.length > 0) {
      return (
        parseFloat(promoCode.slice(5, -1)) <
          parseFloat(welcomePromo[0].name.slice(5, -1)) ||
        cartItems?.promo === promoCode
      );
    } else return true;
  };

  const checkActivable = (subIndex, promo) => {
    const welcomePromo = user.currentPromo
      .filter((item) => item.type === 'welcome')
      .sort((a, b) => a.name.localeCompare(b.name));
    if (welcomePromo[0].name === promoCode) return true;
    else return false;
  };

  const handleNavigateToCart = () => {
    if (isAllowedToPay(cartItems)) {
      navigate(CART);
    } else {
      notifyWarning(
        `Panier inférieur à ${MINIMUM_PRICE}€`,
        "Le montant total du panier doit être d'un montant minimum de 1€ pour passer à l'étape de paiement.",
      );
    }
  };

  const handleGoogle = async () => {
    if (localStorage.getItem('newuser')) {
      localStorage.removeItem('newuser');
    }
    try {
      const data = await HandleGoogle(auth, user);
      dispatch(saveUser(data.newResult.profile, axiosInstance, navigate));
    } catch (e) {
      alert("Une erreur s'est produite");
    }
  };

  const handleFacebook = async (e) => {
    if (localStorage.getItem('newuser')) {
      localStorage.removeItem('newuser');
    }

    try {
      const data = await HandleFacebook(auth, user);
      dispatch(saveUser(data.newResult.profile, axiosInstance, navigate));
    } catch (e) {
      alert("Une erreur s'est produite");
    }
  };

  const handleSignIn = async () => {
    if (localStorage.getItem('newuser')) {
      localStorage.removeItem('newuser');
    }

    const email = inputemail;
    const password = inputpassword;

    try {
      const data = await HandleConnectEmail(auth, email, password, user);
      dispatch(saveUser(data.newResult, axiosInstance, navigate));
    } catch (e) {
      console.log(e);
    }
  };

  const applyPromoWelcome = () => {
    const welcomePromo = user.currentPromo
      .filter((item) => item.type === 'welcome')
      .sort((a, b) => a.name.localeCompare(b.name));
    applyPromo(welcomePromo[0]);
  };
  const checkCurrentActivable = (promoCode) => {
    if (user.currentPromo && user.currentPromo.length > 0) {
      const welcomePromo = user.currentPromo.filter(
        (item) => item.type === 'welcome',
      );
      if (welcomePromo && welcomePromo.length > 0) {
        welcomePromo.sort((a, b) => a.name.localeCompare(b.name));
        if (welcomePromo[0].name === promoCode) return false;
        else return true;
      } else return true;
    }
  };

  const earnPoints = () => {
    if (!cartItems?.orderItems) {
      return 0;
    }
    return cartItems?.orderItems.reduce((acc, product) => {
      if (!product.fidelity) {
        return acc;
      }
      return product.fidelity * product.Qty + acc;
    }, 0);
  };
  const getDelay = (index) => index * 0.5;

  const redirectToConvertPage = () => {
    navigate(CONVERSION);
  };
  const isFriday = async () => {
    const date = new Date();
    if (date.getDay() === 5) {
      try {
        const promoResult = await axiosInstance.get(
          `/promos/pikkoday/${store.id}`,
        );
        setPromoPikkoday(promoResult.data.data);
        setPikkoday(true);
      } catch (e) {
        setPikkoday(false);
      }
    }
  };
  return (
    <div className="w-full h-full bg-white overflow-auto">
      <div className="global-header">
        {' '}
        {/* TODO : Créer un composant générique */}
        <BackButton
          onClick={() => {
            if (user && user._id && user._id.length > 0) navigate(SCAN);
            else navigate(INVITATION);
          }}
        />
        <HeaderCart titre={'Promotions'} />
      </div>
      <div className={`contenaire_promo_screen `}>
        {user && user._id && user._id.length > 0 ? <UserInfo /> : <></>}
        {isPopupVisible ? (
          <div
            onClick={() => setIsPopUpVisible(false)}
            className="h-[100vh] z-[50] w-full fixed top-0 "
          ></div>
        ) : (
          <></>
        )}
        <StepBar step={1} />
        {user && user._id && user._id.length > 0 && (
          <div className="m-[1em] w-full px-8">
            <Pikkopointsbox
              click={() => navigate(RECOMPENSES)}
              user={user}
              earnPoints={earnPoints()}
              pikkoday={pikkoday}
            />
          </div>
        )}
        {isPopupVisible ? (
          <>
            <div className="h-full w-full absolute top-0 text-2xl ">
              <div
                id="popupPromo"
                className="py-12 pt-0 bg-white w-[90%] popupAccount "
              >
                <div
                  className={`bg-gradient1 contenaire_popup_inscription_top${mailvisible ? ' row_top' : ''}`}
                >
                  <div
                    className="close_popup"
                    onClick={() => setIsPopUpVisible(false)}
                  >
                    <img src={closepopup} alt="" />
                  </div>
                  <img
                    className="img_promo5_and_piece "
                    src={promo5euro}
                    alt=""
                  />
                  <div className="flex flex-col gap-4 items-center ">
                    <div
                      className={`30 text-4xl max-w-[250px]${!mailvisible ? '' : ' text-left'}`}
                      style={{ fontFamily: 'geomanistmedium' }}
                    >
                      {inscription
                        ? 'Créer un compte pour profiter des 5€'
                        : 'Connexion'}
                    </div>
                    {!mailvisible ? (
                      <div
                        className="w-[80%] text-[14px] pb-4"
                        style={{ fontFamily: 'Open Sans' }}
                      >
                        Et accède à de nombreux avantages
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
                <div className="flex w-full gap-8 justify-center pb-2">
                  {!mailvisible ? (
                    //  <button onClick={() => setMail(!mailvisible)} className='border-none'>
                    <button
                      onClick={() =>
                        navigate(ACCOUNT, { state: { prevPage: PROMO } })
                      }
                      className="border-none"
                    >
                      <img src={mail} alt="google" />
                    </button>
                  ) : (
                    <></>
                  )}
                  <button onClick={handleGoogle} className="border-none">
                    <img src={google} alt="google" />
                  </button>
                  <button onClick={handleFacebook} className="border-none">
                    <img src={facebook} alt="facebook" />
                  </button>
                </div>
                {/* TODO : EVAL (l'encart en dessous doit être présent ? commenté ? supprimé ?*/}
                {mailvisible ? (
                  <div className="text-3xl font-black w-full flex items-center justify-center gap-4 flex-nowrap ">
                    <hr className="w-[35%]" size="2" color="#EDEDED"></hr>
                    Ou
                    <hr className="w-[35%]" size="2" color="#EDEDED"></hr>
                  </div>
                ) : (
                  <></>
                )}

                <div
                  className={
                    !mailvisible
                      ? 'w-full contenaireinput_p  px-6 max-h-[0px] overflow-scroll'
                      : 'w-full overflow-scroll contenaireinput_promo  px-6 max-h-[500px]'
                  }
                >
                  <div className="inputGroup  flex flex-col items-start w-full">
                    <label
                      htmlFor="email"
                      className="promo_label  geomanistBold"
                    >
                      Email
                    </label>
                    <input
                      className="user_mail_input w-full"
                      type="email"
                      id="email"
                      placeholder="Ton email"
                      name="email"
                      value={inputemail}
                      onChange={(e) => setEmail(e.target.value)}
                      // onChange={(e) => emailRegex.test(e.target.value) ? }
                      // onFocus={clearInput}
                      required
                    />
                  </div>
                  <div className="inputGroup w-full flex flex-col items-start">
                    <label
                      htmlFor="passwordCreate"
                      className="promo_label geomanistBold"
                    >
                      Mot de passe
                    </label>
                    <input
                      className=""
                      type="password"
                      id="passwordCreate"
                      placeholder="Créer un mot de passe"
                      value={inputpassword}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                  </div>
                  {inscription ? (
                    <PrimaryButton
                      onClick={handleSignIn}
                      label={"C'est parti"}
                    />
                  ) : (
                    <>
                      <PrimaryButton
                        onClick={handleSignIn}
                        label={'me connecter'}
                      />
                    </>
                  )}
                </div>

                <div
                  className="popup_promo_change_button"
                  onClick={() => {
                    setInscription(!inscription);
                    setMail(true);
                  }}
                  style={{ fontFamily: 'Open Sans' }}
                >
                  {inscription ? (
                    <>
                      <span>déjà un compte ?</span>
                      <span className="font-semibold popup_promo_change_button_blue ml-4">
                        Je me connecte
                      </span>
                    </>
                  ) : (
                    <>
                      <span>pas de compte ?</span>
                      <span className="font-semibold popup_promo_change_button_blue ml-4">
                        Je crée mon compte
                      </span>
                    </>
                  )}
                </div>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
        {pikkoday && (
          <ul
            className={
              1000 >= 0
                ? '![animation-delay:_' +
                  0.1 +
                  's] w-[90%] appear transform translate-x-[120%] '
                : ' w-[90%] apparition'
            }
          >
            <li>
              <div
                className={`coupons ${activePromoIndex === 1000 ? 'active' : 'tremble'} ${activateLoading ? 'animate-pulse' : ''}`}
              >
                <div className="offert text-2xl flex flex-col items-center ml-3 justify-center">
                  <h1 className="promo-value">
                    {/*{displayCouponNameProperly(promoPikkoday)}*/}
                    x2
                  </h1>
                  <span className="text-[12px]">Points</span>
                </div>
                <img src={tiret_coupons} alt="" />
                <div className="offert2 flex flex-col gap-2 w-full">
                  <div className="flex flex-col gap-2">
                    <div className="geomanistBold text-[1.7rem]">PIKKODAY</div>
                    <span className="text-[14px] font-bold geomanistLight">
                      {promoPikkoday.description}
                    </span>
                  </div>
                </div>
                {promoPikkoday.category !== 'description' && (
                  <span
                    className={`${activePromoIndex == 1000 ? '' : 'payer'} text-[1.7rem] w-[200px] geomanistMedium py-8 p-4`}
                  >
                    {activePromoIndex == 1000 ? 'désactiver' : "J'active"}
                  </span>
                )}
              </div>
            </li>
          </ul>
        )}

        {!user.currentPromo || Object.keys(user.currentPromo).length < 1 ? (
          <>
            <div className=" p-4 min-h-[50%] flex flex-col justify-between ">
              {/* <Pikkopointsbox point={true} click={() => navigate('/account')} /> */}
              <div className="pasDePromoText" onClick={() => navigate('/cart')}>
                <p>Pas d'offres ou de promotions disponible en ce moment </p>
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="promoscreen">
              <div
                className={
                  loadingPromos
                    ? 'promoscreen_loading promoscreen_box'
                    : 'promoscreen_box'
                }
              >
                {/* PROMOTION DE BIENVENUE */}
                {checkAllPromoUsed() ||
                store?.permissions?.promoBienvenue === false ? (
                  // <div className='pasDePromoText' onClick={() => navigate('/cart')}>
                  //   <p>Pas d'offres ou de promotions disponible en ce moment </p>
                  // </div>

                  <></>
                ) : (
                  <div className="contaire_principale_promos-welcome ">
                    <div className="promotitle">
                      <p className="bold">Ton cadeau </p>
                      <p className="opacity-[0.7] promo_small_title">
                        de bienvenue
                      </p>
                    </div>
                    <div className="container_promos_welcome ">
                      {initialWelcomePromoo.map((promoItem, index) => {
                        return (
                          <>
                            <ul
                              className={`![animation-delay:_'+${getDelay()}+'s] welcome_promo_card${checkCurrentActivable(promoItem.name) ? ' unactivable ' : ' activable'}${checkUsed(promoItem.name) ? 'used ' : ''}`}
                            >
                              <div className="promologo">
                                {checkUsed(promoItem.name) ? (
                                  <img src={promoadd} alt="" />
                                ) : (
                                  <img
                                    src={
                                      index === 0
                                        ? promo1
                                        : index === 1
                                          ? promo2
                                          : promo3
                                    }
                                    className={
                                      index > 0 ? 'promo_piece_translate_y' : ''
                                    }
                                    alt=""
                                  />
                                )}
                              </div>
                              <li className={`flex flex-col`}>
                                <div
                                  className={`${checkUsed(promoItem.name) ? ' promo_visit_texte light' : 'promo_visit_texte '}`}
                                >
                                  {/* {promoItem.description} */}
                                  {index === 0
                                    ? '1ère visite'
                                    : index === 1
                                      ? '2éme visite'
                                      : '3éme visite'}
                                </div>
                                <div className="promo_offert_box">
                                  {checkUsed(promoItem.name) ? (
                                    <></>
                                  ) : (
                                    <>
                                      <h1
                                        className={`promo_offert_price${checkCurrentActivable(promoItem.name) ? ' unactivable ' : ''}`}
                                      >
                                        {promoItem.name
                                          .slice(5)
                                          .replace('e', '€')}
                                      </h1>
                                      <span className="promo_offert_title">
                                        Offert
                                      </span>
                                    </>
                                  )}
                                </div>
                              </li>
                              {!checkCurrentActivable(promoItem.name) ? (
                                !checkUsed(promoItem.name) ? (
                                  <div className="promo_active_button">
                                    <button
                                      className="w-full"
                                      onClick={applyPromoWelcome}
                                    >
                                      <p className="flex payer w-full p-4 jigglescale geomanistBold text-[1.6rem]">
                                        Activer
                                      </p>
                                    </button>
                                  </div>
                                ) : (
                                  <div className="promo_active_button">
                                    <button
                                      className="w-full"
                                      onClick={applyPromoWelcome}
                                    >
                                      <p className="promo_active_button_desactiver flex  grayscale w-full p-2">
                                        Désactiver
                                      </p>
                                    </button>
                                  </div>
                                )
                              ) : (
                                <></>
                              )}
                            </ul>
                          </>
                        );
                      })}
                    </div>
                  </div>
                )}
                {/* PROMOTION CADEAUX */}
                {user && user._id ? (
                  <div className="promo-container">
                    <div className="font-bold text-[22px]">Mes coupons</div>
                    {sortedPromoCadeaux.map((promoItem, index) => {
                      const delay = index * 0.5;
                      return (
                        <>
                          <ul
                            onClick={() => applyPromo(promoItem, index)}
                            className={
                              index >= 0
                                ? '![animation-delay:_' +
                                  delay +
                                  's] w-full appear transform translate-x-[120%] '
                                : ' w-full apparition'
                            }
                          >
                            <li>
                              <div
                                className={
                                  activePromoIndex === index
                                    ? `coupons active`
                                    : 'coupons'
                                }
                              >
                                <div className="offert text-2xl  flex flex-col  items-center ml-3  justify-center">
                                  <h1 className="promo-value">
                                    {displayCouponNameProperly(promoItem)}
                                  </h1>
                                  <span className="text-[12px]">Offert</span>
                                </div>
                                <img src={tiret_coupons} alt="" />
                                <div className="offert2 flex flex-col gap-2 w-full">
                                  <div className="flex flex-col gap-2  ">
                                    <div className="geomanistBold text-[1.7rem]">
                                      Réductions
                                    </div>
                                    <span className="text-[14px] font-bold geomanistLight">
                                      {promoItem.description}
                                    </span>
                                  </div>
                                </div>
                                <span
                                  className={`${activePromoIndex === index ? '' : 'payer'} text-[1.7rem] w-[200px]  geomanistMedium py-8 p-4`}
                                >
                                  {activePromoIndex === index ? (
                                    <>désactiver</>
                                  ) : (
                                    <> J'active</>
                                  )}
                                </span>
                              </div>
                            </li>
                          </ul>
                        </>
                      );
                    })}
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </>
          //   )}
          // </>
        )}
      </div>
      <div className="promo-footer-button-container">
        {!!user._id && (
          <PrimaryButton
            label="Convertir mes Pikkos points"
            onClick={redirectToConvertPage}
          />
        )}
        <button
          className={
            'non_merci_promo  w-[100%] ![animation-delay:_' + 0.75 + 's]'
          }
          onClick={handleNavigateToCart}
        >
          {!user?.currentPromo ||
          (user.currentPromo.filter((item) => item.type === 'welcome').length <=
            0 &&
            promoCadeaux().length < 1) ||
          cartItems?.promo?.length > 0 ||
          !store?.permissions?.promoBienvenue ? (
            <span>
              Suivant <img src={arrow} alt="next" />
            </span>
          ) : (
            <span>
              Non merci je ne veux pas de promos{' '}
              <img className="arrow-right" src={arrow} alt="next" />
            </span>
          )}
        </button>
      </div>
    </div>
  );
};

export default PromoScreen;
